import PropTypes from "prop-types";
import { Button } from "@progress/kendo-react-buttons";
import Body from "commons/card/Body";
import React, { Fragment } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import propTypes from "prop-types";
import LoaderContainer from "commons/container/LoaderContainer";
import {
  useGetDiffuseursQuery,
  useGetFormatsPageQuery,
  useGetThematiqueQuery,
} from "../../redux/api/cache";

function fillNotes(listNotes, dataNotes) {
  let loop = false;
  let note = {};
  listNotes.forEach((item) => {
    if (
      note[Object.keys(item)[0]] === undefined &&
      item[Object.keys(item)[0]] != null
    ) {
      note[Object.keys(item)[0]] = item[Object.keys(item)[0]];
      item[Object.keys(item)[0]] = null;
      loop = true;
    }
  });

  if (loop) {
    dataNotes.push(note);
    fillNotes(listNotes, dataNotes);
  }
}

export default function ArrayFormatter(props) {
  const {
    data: diffuseurs,
    isLoading: isDiffuseursLoading,
    isFetching: isDiffuseursFetching,
  } = useGetDiffuseursQuery(props.media);
  const {
    data: thematiques,
    isLoading: isThematiquesLoading,
    isFetching: isThematiquesFetching,
  } = useGetThematiqueQuery();
  const {
    data: formatsPage,
    isLoading: isFormatsPagesLoading,
    isFetching: isFormatsPageFetching,
  } = useGetFormatsPageQuery({ media: "", diff: "", format: "" });

  const listNotes = [];
  props.data.data.forEach((item) => {
    let temp = listNotes.find(
      (note) =>
        note[item.campr_date] &&
        (note[item.campr_date].diffuseur === item.diff_cd ||
          note[item.campr_date].diffuseur === item.them_cd) &&
        Object.keys(note)[0] === item.campr_date &&
        note[item.campr_date].mf_format === item.mf_format
    );
    if (temp === undefined) {
      listNotes.push({
        [item.campr_date]: {
          diffuseur: item.diff_cd ? item.diff_cd : item.them_cd,
          mf_format: item.mf_format,
        },
      });
    }
  });

  const dataNotes = [];
  fillNotes(listNotes, dataNotes);

  var ordered = null;

  if (dataNotes.length !== 0) {
    ordered = Object.keys(dataNotes[0])
      .sort()
      .reduce((obj, key) => {
        obj[key] = dataNotes[0][key];
        return obj;
      }, {});
  }

  const CustomCell = (data) => {
    const field = data.field;
    const value = data.dataItem[field];
    let diffuseur = undefined;
    let send = "redButton";

    if (diffuseurs !== undefined) {
      diffuseur = diffuseurs.data.find(
        (item) => item.diff_cd === value?.diffuseur
      );
    }

    if (props.numeric) {
      props.data.data.forEach((elem) => {
        if (
          elem.campr_date === field &&
          elem.diff_cd === value?.diffuseur &&
          elem.mf_format === value?.mf_format &&
          !elem.campr_instr_envoi
        ) {
          send = "blackButton";
        }
      });
    } else {
      send = "blackButton";
    }
    send =
      props.selectedRow &&
      props.selectedRow.campr_date === field &&
      props.selectedRow.mf_format === value?.mf_format &&
      (props.selectedRow.diff_cd === value?.diffuseur ||
        props.selectedRow.them_cd === value?.diffuseur)
        ? "greyButton"
        : send;

    return (
      <td>
        <Button
          className={send}
          onClick={() => {
            let selectedData = props.data.data.find(
              (item) =>
                item.campr_date === field &&
                item.mf_format === value?.mf_format &&
                (item.diff_cd === value?.diffuseur ||
                  item.them_cd === value?.diffuseur)
            );
            props.setSelectedRow(selectedData);
            let dataValue = {
              campr_date: selectedData.campr_date,
              diff_cd: selectedData.diff_cd,
              campr_dt_limite: selectedData.campr_dt_limite,
              rid: selectedData.rid,
              them_cd: selectedData.them_cd,
              mf_format: selectedData.mf_format,
            };
            props.outputData(dataValue);
          }}
          style={{
            visibility: value === undefined ? "hidden" : "visible",
            fontSize: "15px",
          }}
        >
          {(diffuseur === undefined
            ? thematiques?.data.find(
                (item) => item.them_cd === value?.diffuseur
              )?.them_descr
            : diffuseur.diff_nom) +
            (value?.mf_format
              ? ` (${
                  formatsPage?.data?.find(
                    (f) => f.mf_format === value.mf_format
                  )?.mf_description
                })`
              : "")}
        </Button>
      </td>
    );
  };

  const columns = (() => {
    const cols = [];
    if (ordered != null) {
      for (let i = 0; i < Object.keys(ordered).length; i++) {
        cols.push(
          <GridColumn
            key={i}
            field={Object.keys(ordered)[i]}
            width={300}
            minResizableWidth={100}
            cell={CustomCell}
          />
        );
      }
    } else {
      cols.push(<GridColumn title={""} key={1} />);
    }

    return cols;
  })();

  return (
    <Fragment>
      <Body style={{ height: props.show ? "" : "0" }}>
        {!isDiffuseursFetching &&
          !isDiffuseursLoading &&
          !isThematiquesFetching &&
          !isThematiquesLoading &&
          !isFormatsPageFetching &&
          !isFormatsPagesLoading && (
            <Grid data={dataNotes} resizable={true}>
              {columns}
            </Grid>
          )}
        {(isDiffuseursFetching ||
          isDiffuseursLoading ||
          isThematiquesFetching ||
          isThematiquesLoading ||
          isFormatsPageFetching ||
          isFormatsPagesLoading) && <LoaderContainer />}
      </Body>
    </Fragment>
  );
}

ArrayFormatter.propTypes = {
  media: PropTypes.any,
  numeric: PropTypes.bool,
  data: PropTypes.shape({
    data: PropTypes.array,
    meta: PropTypes.shape({
      definition: PropTypes.array,
    }),
  }),
  show: propTypes.bool,
  outputData: PropTypes.func.isRequired,
  selectedRow: PropTypes.any,
  setSelectedRow: PropTypes.any,
};
